import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { DamageInfosManagement } from '../components/DamageInfosManagement';
import { useNavigate } from 'react-router-dom';
import { TDamageSchema, damageSchema } from '@/schemas/damage/damage.schema';
import { useCreateDamage } from '@/hooks/damage.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateDamagePage = () => {
  const { t } = useTranslation('damage');
  const navigate = useNavigate();

  const {
    watch: watchDamage,
    control: damageControl,
    register: registerDamage,
    setValue: setDamageValue,
    setError: setDamageError,
    handleSubmit: handleSubmitDamage,
    formState: { errors: damageErrors, isSubmitting: isSubmittingDamage },
  } = useForm<TDamageSchema>({
    resolver: zodResolver(damageSchema),
  });

  const { mutate: mutateCreateDamage, isPending: isPendingCreateDamage } =
    useCreateDamage({
      t,
      handleSuccess: () => navigate('/damages'),
    });

  const onSubmitDamage = (damage: TDamageSchema) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...damage,
      languageCode,
    };

    mutateCreateDamage(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/damages"
        title={t('common:damage')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem text={t('damageList')} linkTo="/damages" />
            <BreadcrumbItem text={t('common:damage')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <DamageInfosManagement<TDamageSchema>
          t={t}
          watch={watchDamage}
          control={damageControl}
          register={registerDamage}
          setValue={setDamageValue}
          setError={setDamageError}
          errors={damageErrors}
          submitDisabled={isSubmittingDamage || isPendingCreateDamage}
          onSubmit={handleSubmitDamage(onSubmitDamage)}
        />
      </div>
    </>
  );
};
